import React from 'react'
import Position from '../../../components/Position';
import Highlight from '../../../components/Highlight';
import { Container, Space, Center, Grid } from '../../../GlobalStyles';
import { StaticImage } from "gatsby-plugin-image";

import useI18n from '../../../i18n/useI18n';

const Description = ({ location }) => {

    const { translateObject } = useI18n();
    const highlightTitle = {
        en: 'What do',
        es: '¿Qué piensan'
    }    
    const title = {
        en: 'customers think about you',
        es: 'tus clientes sobre ti?'
    }
    
    return (
        <Container>
            <Space />
            <Position location={location} />
            <Center>
                <h2 data-sal="slide-up" data-sal-easing="ease-in-circ">
                    <Highlight text={translateObject(highlightTitle)} /> {translateObject(title)}
                </h2>
                <p data-sal="slide-up" data-sal-easing="ease-in-circ" data-sal-delay=".2s">
                    {translateObject({
                        en: `You have already created your survey through the Survey Creator, it is time to apply it to your clients and obtain the information you require from them.`,
                        es: `Una vez creadas tus encuestas con Survey Creator, es tiempo de aplicarlas a tus clientes y obtener información de ellas.`
                    })}                    
                </p>
            </Center>


            <Grid>
                <div className='col-1'data-sal='slide-right' data-sal-easing="ease-in-circ">
                    <h3>
                        {translateObject({
                            en: `Know how was the service provided`,
                            es: `Entérate de cómo fue el servicio`
                        })}
                    </h3>
                    <p>
                        {translateObject({
                            en: `Providing a great experience to your clients when using your services
                            is of the utmost importance, know through surveys if the expectations
                            of your clients are being met or if there is a problem with the service.`,
                            es: `Es importante dar una gran experiencia a tus clientes que utilizan tus servicios, 
                            con Dotell podrás saber a través de encuestas si las expectativas
                            de tus clientes están siendo atendidas o si hay algún problema con el servicio.`
                        })}
                        
                    </p>
                </div>

                <div className='col-2'data-sal="slide-up" data-sal-easing="ease-in-circ" data-sal-duration='300'>
                    <StaticImage
                        src="../../../images/dotell-1.png"
                        quality={95}
                        formats={["auto", "webp", "avif"]}
                        alt="dotell-1"
                        style={{ width: '100%', height: 'fit-content' }}
                    />
                </div>

                <div className='col-3'data-sal='slide-left' data-sal-easing="ease-in-circ">
                    <h3>
                        {translateObject({
                            en: `Get contact of your customers`,
                            es: `Obtén el contacto de tus clientes`
                        })}
                    </h3>
                    <p>
                        {translateObject({
                            en: `With the use of forms within your surveys, obtain relevant contact information from your clients, 
                            in this way you can follow up on clients who have requested it to ensure that their experience is always perfect.`,
                            es: `Utiliza un formulario de contacto en tus encuestas para obtener información de tus clientes, de esta manera
                            podrás dar seguimiento a clientes que lo soliciten para asegurarte que la experiencia siempre es perfecta.`
                        })}
                    </p>
                </div>
            </Grid>
        </Container>
    )
};

export default Description;